var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "flkloc5zla",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 4.375v-1.25c0-.375.25-.625.625-.625s.625.25.625.625v1.25c0 .375-.25.625-.625.625s-.625-.25-.625-.625zM6.25 10A3.761 3.761 0 0 1 10 6.25 3.761 3.761 0 0 1 13.75 10 3.761 3.761 0 0 1 10 13.75 3.761 3.761 0 0 1 6.25 10zm1.25 0c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5A2.507 2.507 0 0 0 7.5 10zm3.125 6.875v-1.25c0-.375-.25-.625-.625-.625s-.625.25-.625.625v1.25c0 .375.25.625.625.625s.625-.25.625-.625zM4.687 5.562a.604.604 0 0 1 0-.875c.25-.25.625-.25.875 0l.875.875c.25.25.25.625 0 .875-.062.125-.25.188-.437.188a.567.567 0 0 1-.438-.188l-.875-.875zm10.625 9.75a.604.604 0 0 0 0-.874l-.874-.876a.604.604 0 0 0-.876 0 .604.604 0 0 0 0 .876l.876.874a.675.675 0 0 0 .437.188.675.675 0 0 0 .438-.188zM4.376 10.625h-1.25c-.375 0-.625-.25-.625-.625s.25-.625.625-.625h1.25c.375 0 .625.25.625.625s-.25.625-.625.625zm12.5 0c.375 0 .625-.25.625-.625s-.25-.625-.625-.625h-1.25c-.375 0-.625.25-.625.625s.25.625.625.625h1.25zM6.437 13.563c.25.25.25.624 0 .874l-.875.876a.675.675 0 0 1-.437.187.675.675 0 0 1-.438-.188.604.604 0 0 1 0-.874l.875-.876c.25-.25.688-.25.875 0zm7.125-8a.604.604 0 0 0 0 .875c.063.125.313.187.438.187a.675.675 0 0 0 .438-.188l.874-.875a.604.604 0 0 0 0-.875.604.604 0 0 0-.874 0l-.876.875z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flkloc5zla)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSun);
export default __webpack_public_path__ + "static/media/ic-sun.1f5d7672e6b3d751bf5bdf174b792f19.svg";
export { ForwardRef as ReactComponent };